import {useSelector} from 'react-redux'
import {useHopperAdEligibility} from 'components/HopperAds/hooks/useHopperAdEligibility'
import {
  getIsAnchorScenario,
  getShowHostelsAlert
} from 'modules/sapiSearch/selectors'
import {
  getIsAnchorHotelHidden,
  getIsUserClosedHostelAlert,
  getMlos
} from 'modules/search/selectors'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

export const useIsBannerTopSlotOccupied = (): boolean => {
  const mlos = useSelector(getMlos)
  const showHostelsAlert = useSelector(getShowHostelsAlert)
  const isUserClosedHostelAlert = useSelector(getIsUserClosedHostelAlert)
  const isAnchorHotelHidden = useSelector(getIsAnchorHotelHidden)
  const isAnchorScenario = useSelector(getIsAnchorScenario)
  const {isEligible: isHopperAdEligible} = useHopperAdEligibility('Banner')
  const {
    commerce: {coBranded}
  } = useBrandCapabilities()

  return Boolean(
    mlos ||
      (showHostelsAlert && !isUserClosedHostelAlert) ||
      isAnchorHotelHidden ||
      (isHopperAdEligible && !isAnchorScenario) ||
      coBranded.enabled
  )
}
